import React, { useState } from 'react'
import useOuterClick from '../../hooks/useOuterClick'

const InfoTag = ({text, className}) => {

    const [open, setOpen] = useState(false)
    const tooltipRef = useOuterClick((e)=>{
        setOpen(false)
    })
    const clickHandler = () => {
        setOpen( !open )
    }


    return (
        <span ref={tooltipRef} className={'tooltip-wrapper ' + className} onClick={clickHandler}>
            <InfoIcon />
            { open &&
                <ToolTip text={text} />
            }
        </span>
    )

}

export default InfoTag


const ToolTip = ({onClick, text}) => {

    return (
        <span onClick={onClick} className="tooltip">{text}</span>
    )
}


const InfoIcon = () => {


    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27">
            <g id="Icon:_Info" data-name="Icon: Info" transform="translate(1 1)">
                <circle id="Ellipse_2" data-name="Ellipse 2" cx="12.5" cy="12.5" r="12.5" fill="none" />
                <path id="Path_30" data-name="Path 30" d="M-21684.52-8719.428v8.333" transform="translate(21697.02 8729.427)" fill="none" />
                <path id="Path_31" data-name="Path 31" d="M-21684.52-8719.428v1.667" transform="translate(21697.02 8726.096)" fill="none" />
            </g>
        </svg>
    )
}